// AI Generated Test
import { Component } from '@angular/core';

@Component({
    selector: 'page-fix-checks',
    standalone: false,
    template: `
        <page-header [icon]="['PAGE_FIX', 'ACCESSIBILITY_CHECKS'] | monIcons"
                     [header]="'PageCorrect accessibility fixes' | translate"
                     [subHeader]="'List of improvements that can be applied to your website to improve your Accessibility Compliance' | translate">
        </page-header>
        <page-fix-accessibility-checks>
        </page-fix-accessibility-checks>
    `,
})
export class PageFixChecksComponent {
    constructor () {}
}
